<template>
  <main class="min-h-screen xl:bg-background bg-[#fff]">
    <!-- <router-link :to="{ name: '/home' }">
      <LoginLogo
        class="absolute left-4 md:left-6 z-[1]"
        :class="{
          'top-2': theme === 'kids',
          'top-4': theme === 'default',
        }"
      />
    </router-link>

    <div class="absolute right-4 md:right-6 top-4 hidden xl:block">
      <LocalesSwitcher list-position="left" />
    </div>
    <div class="absolute right-4 md:right-6 top-4 xl:hidden z-10">
      <button
        v-if="!isOpenMenu"
        type="button"
        class="flex items-center gap-2 uppercase text--md text-primary"
        @click="isOpenMenu = !isOpenMenu"
      >
        {{ $i18n.locale }}
        <i-mdi-web class="text-[21px] md:text-[31px]" />
      </button>

      <button
        v-else
        type="button"
        class="flex items-center gap-2 uppercase text--md text-[20px] text-primary bg-background rounded-[5px]"
        @click="isOpenMenu = !isOpenMenu"
      >
        <i-material-symbols-close-rounded />
      </button>
    </div> -->

    <div
      class="flex items-center flex-col-reverse xl:flex-row mx-auto min-h-screen pb-4 md:max-w-full xl:p-0 px-4 md:px-6"
      :class="{
        'md:pt-20': theme === 'default',
        'justify-end': isOpenMenu,
        'justify-center': !isOpenMenu,
      }"
    >
      <section v-show="!isOpenMenu" class="xl:h-screen xl:w-1/2 h-sceen xl:block block flex-col items-center gap-[50px]">
        <div class="min-h-full rounded-[1.25rem] xl:rounded-l-none" :class="`form-section-${theme}`">
          <router-link v-show="theme === 'default'" :to="{ name: '/home' }" class="xl:block hidden pt-[16px] container-main">
            <LoginLogo
              :class="{
                'top-4 mb-[50px]': theme === 'default',
              }"
            />
          </router-link>
          <div v-show="theme === 'kids'" class="xl:flex hidden w-[472px] mt-[16px] container mb-[50px]">
            <LoginHeaderKids />
          </div>
          <div>
            <div class="md:py-[72px] md:px-[140px] xl:h-full xl:p-0">
              <div class="h-full flex justify-center items-center">
                <slot></slot>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        v-show="!isOpenMenu"
        class="xl:h-screen py-[18px] px-[40px]md:bg-background rounded-[1.25rem] w-full md:p-0 md:mx-0 xl:w-1/2 block xl:justify-center xl:items-center"
      >
        <div class="flex justify-center items-center min-h-full" :class="`banner-section-${theme}`">
          <figure class="w-full h-full flex justify-center items-center">
            <img loading="lazy" class="w-full" :src="'/img/login-page/' + siteTheme.images.logoBanner" alt="banner" />
          </figure>
        </div>
      </section>
      <LoginHeaderKids v-show="theme === 'kids'" @handle-open="handleOpenNav" class="xl:hidden w-full" :is-open="isOpenMenu" />
      <router-link v-show="theme === 'default'" :to="{ name: '/home' }" class="block xl:hidden pt-[16px] container-main">
        <LoginLogo
          :class="{
            'top-4': theme === 'default',
          }"
        />
      </router-link>
      <!-- <LoginMenu v-if="isOpenMenu" @close-menu="isOpenMenu = false" /> -->
    </div>
  </main>
</template>

<script setup>
import { theme } from "@/services/getSiteTheme"
import siteTheme from "@/static/site-themes"
import { ref } from "vue"

import LoginHeaderKids from "@/components/login/LoginHeaderKids.vue"

defineProps({
  isLoading: {
    type: Boolean,
    default: false,
  },
})

const isOpenMenu = ref(false)

const handleOpenNav = () => {
  isOpenMenu.value = !isOpenMenu.value
}
</script>

<style lang="scss" scoped>
.banner-section {
  @media (max-width: 767px) {
    &-default {
      background: linear-gradient(103.81deg, #43784e 6.78%, #2f4f75 94.12%);
    }
  }
  &-kids {
    background-color: #fff;
  }
}

.form-section {
  &-default {
    background: linear-gradient(103.81deg, #43784e 6.78%, #2f4f75 94.12%);
  }

  &-kids {
    @apply xl:bg-[#f3f3f3] md:bg-primary bg-[#fff];
    // background-color: #f3f3f3;;;
  }

  @media (max-width: 768px) {
    &-default {
      @apply bg-background;
    }
    &-kids {
      background-color: #fff;
    }
  }
}
</style>
